/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

// Render a Panel content type
//
// Most likely, your object has a reference to a panel that was resolved.
// e.g. left_panel_ref.  Pass the first element in that ref.  E.g. <Panel data={left_panel_ref[0]} />

import React from 'react';
import { object, array, bool } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';
import LinkList from '../LinkList/LinkList';
import Copy from '../Copy';
import replaceSpecialChar from '../../../helpers/replaceSpecialChar';
import { getSSRDeviceType } from '../../../../state/ducks/App/App-Selectors';

const useStyles = () => ({
    relative: {
        position: 'relative',
        '& .messageCopy': {
            textWrap: 'pretty',
        },
    },
    heroRedesignContent: {
        marginBottom: '16px',
    },
    heading: {
        // margin: '-8px auto 0px auto',
        '& *': {
            fontSize: '1.5em',
            textAlign: 'left',
            fontFamily: 'Crimson, Garamond, Times, serif',
        },
    },
    subHeading: {
        position: 'absolute',
        right: '32px',
        top: '32px',
        padding: '20px 24px',
        width: 'clamp(200px, 20%, 344px)',
        background: 'rgba(255, 255, 255, 0.80)',
        borderRadius: '5px',
        '& *': {
            textAlign: 'left',
            fontSize: '16px',
        },
    },
});

function sanitizeCSS(s) {
    return s.replace(/[^-_.a-zA-Z0-9]/g, '');
}

// function Panel2(data) {
//     const returnValue = [];
//     if (!Array.isArray(data)) {
//         return [];
//     }
//     if (data.message_collection && Array.isArray(data.message_collection)) {
//         data.message_collection.forEach((item) => {
//             const k = Object.keys(item)[0];
//             switch (k) {
//                 case 'copy':
//                     returnValue.push(<Copy block={item.copy} />);
//                     break;
//                 default:
//                     mbpLogger.logWarning({ appName: process.env.npm_package_name, message: `Unhandled Panel component: ${sanitizeCSS(k)}` });
//             }
//         });
//     }

//     return returnValue;
// }

// Panel2.propTypes = {
//     data: object.isRequired,
// };

const DepartmentPanelV2 = ({
    classes,
    data,
    styleData,
    departmentPageHeroRedesign,
}) => {
    if (data) {
        const ssrDeviceType = useSelector(getSSRDeviceType);
        const checkDeviceType = ssrDeviceType === 'desktop' || ssrDeviceType === 'tablet';
        const position = styleData?.position !== undefined && styleData?.position;
        const heading = data?.message_collection?.[0]?.copy?.copy;
        const isMobileDevice = ssrDeviceType === 'mobile';
        const subHeading = data?.message_collection?.[1]?.copy?.copy;
        const linkListIndex = () => {
            const messageBlock = data.message_collection || [];
            let i;
            let index = -1;
            for (i = 0; i < messageBlock.length; i += 1) {
                if ('link_list' in messageBlock[i]) {
                    index = i;
                }
            }
            return index;
        };

        let linkList;
        const linkListIndexOf = linkListIndex();
        if (linkListIndexOf !== -1) {
            linkList = <LinkList data={data.message_collection?.[linkListIndexOf]} departmentPageHeroRedesign={departmentPageHeroRedesign} />;
        }

        const parseContent = replaceSpecialChar(heading);
        return (
            <div style={{ position }}>
                <div className={classes.heroRedesignContent}>
                    {((data?.isMobileCopy && isMobileDevice) || checkDeviceType) && <ReactMarkdown className={`${classes.heading}`} source={parseContent} escapeHtml={false}  />}
                    {((subHeading && isMobileDevice) || checkDeviceType) && <ReactMarkdown className={isMobileDevice ? '' : classes.subHeading} source={replaceSpecialChar(subHeading)} escapeHtml={false} />}
                </div>
                {linkList}
            </div>
        );
    }
    return <></>;
};

DepartmentPanelV2.propTypes = {
    classes: object.isRequired,
    data: object.isRequired,
    styleData: array,
    departmentPageHeroRedesign: bool,
};
DepartmentPanelV2.defaultProps = {
    styleData: [],
    departmentPageHeroRedesign: false,
};

export default withStyles(useStyles)(DepartmentPanelV2);
